"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.warningIcon = exports.spinnerIconText = exports.spinnerIcon = exports.spinnerContainer = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.white, ";border-radius:", (0, _util.rem)(4), ";display:flex;align-items:center;padding:", (0, _util.rem)(8), " ", (0, _util.rem)(24), " ", (0, _util.rem)(8), " ", (0, _util.rem)(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var controls = /*#__PURE__*/(0, _react.css)("display:inline-flex;justify-content:flex-end;border-radius:16px;padding-left:", (0, _util.rem)(12), ";flex-shrink:0;min-width:", (0, _util.rem)(118), ";button{border-radius:16px;margin-right:8px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
var bareControls = process.env.NODE_ENV === "production" ? {
  name: "w45tux",
  styles: "padding-left:0;min-width:auto;display:flex"
} : {
  name: "ae3jv9-bareControls",
  styles: "padding-left:0;min-width:auto;display:flex;label:bareControls;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var infoBox = function infoBox(theme) {
  return /*#__PURE__*/(0, _react.css)("margin-left:auto;color:", theme.color.monochrome.mediumDark, ";font-size:11px;a{color:#0080d9;}div{display:inline-flex;background-color:", theme.color.monochrome.medium, ";border-style:solid;border-radius:50%;border-color:", theme.color.monochrome.medium, ";align-items:center;justify-content:space-around;height:25px;width:25px;margin-right:8px;font-weight:bold;font-size:13px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:infoBox;"));
};

var spinnerContainer = function spinnerContainer(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;justify-content:center;align-items:center;height:", (0, _util.rem)(200), ";width:100%;background-color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:spinnerContainer;"));
};

exports.spinnerContainer = spinnerContainer;
var textContainer = /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:row;align-items:center;justify-content:center;margin-top:-", (0, _util.rem)(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textContainer;"));
var spinnerIcon = /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(36), ";padding:", (0, _util.rem)(8), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:spinnerIcon;"));
exports.spinnerIcon = spinnerIcon;

var spinnerIconText = function spinnerIconText(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", theme.fontSize.medium, ";font-weight:", theme.fontWeight.medium, ";flex-align:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:spinnerIconText;"));
};

exports.spinnerIconText = spinnerIconText;

var warningIcon = function warningIcon(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.negative, ";display:block;height:", (0, _util.rem)(48), ";width:", (0, _util.rem)(48), ";margin:auto;margin-bottom:", (0, _util.rem)(16), ";border:solid 2px ", theme.color.secondary.negativeAlt, ";background-color:", theme.color.secondary.negativeAlt, ";border-radius:50%;padding-bottom:3px;" + (process.env.NODE_ENV === "production" ? "" : ";label:warningIcon;"));
};

exports.warningIcon = warningIcon;
var styles = {
  base: base,
  controls: controls,
  bareControls: bareControls,
  infoBox: infoBox,
  textContainer: textContainer,
  spinnerIcon: spinnerIcon,
  spinnerContainer: spinnerContainer,
  spinnerIconText: spinnerIconText,
  warningIcon: warningIcon
};
exports.styles = styles;
//# sourceMappingURL=Ai.styles.js.map